const uiSchema = () => ({
  // temporarily disabled: react-mapbox-gl production crash (MapboxGl getter)
  // location: {
  //   'ui:field': 'location',
  //   'ui:options': {
  //     xs: 12,
  //     sm: 12,
  //     md: 12,
  //     lg: 12,
  //     xl: 12,
  //   },
  // },
});

export default uiSchema;
